import React from 'react';
import { Box } from '@material-ui/core';

const Column = ({ children }) => {
    return <Box width="100%">{children}</Box>;
};

export default Column;
